<template>
  <div>
    <el-card
      style="height: 100%"
      shadow="always"
      v-loading="loading"
      :body-style="{ padding: '0px' }"
    >
      <div role="warning" class="alert alert-warning m-0 py-1 text-navy">
        <strong>Please be aware the below balances update daily.</strong> To see
        future balances please generate a statement or contact our office on
        <i>02 67509400</i>
      </div>
      <div class="row p-3">
        <div
          class="col-md-12 d-flex align-items-center justify-content-between"
        >
          <h3 class="text-navy d-none d-lg-block">Trades</h3>
          <h3
            class="text-navy d-lg-none"
            v-if="selectedOption && selectedPageOption"
          >
            {{ selectedPageOption.name }}
          </h3>
          <div>
            <el-button
              v-if="!isProducer"
              @click="showPurchaseModal($event)"
              class="btn-primary"
            >
              New Purchase
            </el-button>
            <el-button
              v-if="false"
              class="btn-primary"
              @click="formModalShow = true"
            >
              New Sale
            </el-button>
            <div class="text-right mt-2">
              <small class="text-navy"
                >As at:
                <strong>{{ moment().format("DD/MM/YYYY") }}</strong></small
              >
            </div>
          </div>
        </div>
        <div class="col-12 d-none d-lg-block">
          <el-tabs v-model="tabValue" type="card" @tab-click="getData(1)">
            <el-tab-pane
              v-for="(item, index) in tabs"
              :key="item.name"
              :label="item.name"
              :name="item.value"
            >
              <div v-loading="loading">
                <el-table
                  :data="purchases.data"
                  :cell-class-name="tableCellClassName"
                  :header-cell-class-name="tableCellClassName"
                >
                  <el-table-column label="" prop="id" width="60px">
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.bsa_executed_collections.length > 0 &&
                          scope.row.invoice_collections.length > 0 &&
                          !['draft', 'pending'].includes(item.value)
                        "
                      >
                        <el-dropdown>
                          <el-button class="btn-secondary p-1">
                            <i class="far fa-download"></i>
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <invoice-button
                                :initial_purchase="scope.row"
                                :show_item="true"
                                v-if="scope.row.invoice_collections.length > 0"
                              ></invoice-button>
                              <bsa-executed-button
                                :initial_purchase="scope.row"
                                :show_item="true"
                                v-if="
                                  scope.row.bsa_executed_collections.length > 0
                                "
                              ></bsa-executed-button>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div
                        v-else-if="!['draft', 'pending'].includes(item.value)"
                      >
                        <invoice-button
                          :initial_purchase="scope.row"
                          v-if="scope.row.invoice_collections.length > 0"
                        ></invoice-button>
                        <bsa-executed-button
                          :initial_purchase="scope.row"
                          v-if="scope.row.bsa_executed_collections.length > 0"
                        ></bsa-executed-button>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Trade #" prop="ref_id" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.ref_id }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Purchase Date"
                    width="120"
                    v-if="['draft', 'pending'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.bill_invoice_date
                          ? moment(scope.row.bill_invoice_date).format(
                              "DD/MM/YYYY",
                            )
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Reference Code"
                    prop="reference_code"
                  />
                  <el-table-column
                    label="Nominated PIC"
                    prop="property.pic"
                    v-if="['draft', 'pending'].includes(item.value)"
                  />
                  <el-table-column
                    label="Term"
                    prop="agent_advised_term"
                    v-if="['draft', 'pending'].includes(item.value)"
                  />
                  <el-table-column
                    :label="
                      ['draft', 'pending'].includes(item.value)
                        ? 'Number of Head'
                        : 'Original Head'
                    "
                    prop="number_of_head"
                    align="center"
                  />
                  <el-table-column
                    :label="
                      ['draft', 'pending'].includes(item.value)
                        ? 'Bill Value (inc)'
                        : 'Original Bill Value (inc)'
                    "
                    prop="number_of_head"
                    v-if="!['draft', 'pending'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.dollar_value
                          ? "$" + $_toLocaleString(scope.row.dollar_value)
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Daily Rate"
                    prop="channel.id"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.channel && scope.row.channel.daily_rate
                          ? $_roundAccurately(scope.row.channel.daily_rate, 4) +
                            "%"
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="DOF"
                    prop="channel.id"
                    align="center"
                    v-if="!['draft', 'pending', 'closed'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      {{
                        moment().diff(scope.row.invoice_invoice_date, "days")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Sales (pending)"
                    v-if="!['draft', 'pending'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.sales
                          ? `${scope.row.sales.length} (${scope.row.sales.filter((x) => x.sale_status_id != 8).length})`
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Total Mgmt Fee Paid"
                    v-if="item.value == 'closed'"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.management_fee_total
                          ? "$" +
                            $_toLocaleString(scope.row.management_fee_total)
                          : "--"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Pending Sales (Inc)"
                    v-if="item.value == 'open'"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.pending_total_sales_inc
                          ? "$" +
                            $_toLocaleString(scope.row.pending_total_sales_inc)
                          : "--"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Paid Sales (Inc)"
                    v-if="item.value == 'open'"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.total_sales_inc
                          ? "$" + $_toLocaleString(scope.row.total_sales_inc)
                          : "--"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Deposit Balance"
                    v-if="item.value == 'open'"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.livestock_deposit
                          ? "$" + $_toLocaleString(scope.row.livestock_deposit)
                          : "--"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Expiry Date"
                    width="110"
                    v-if="item.value == 'open'"
                  >
                    <template slot-scope="scope">
                      <div
                        :class="expiredDates(scope.row.invoice_due_date)"
                        class="text-center"
                        style="width: 100px"
                        v-if="tabValue == 'open'"
                      >
                        {{
                          scope.row.invoice_due_date
                            ? moment(scope.row.invoice_due_date).format(
                                "DD/MM/YYYY",
                              )
                            : ""
                        }}
                      </div>
                      <div v-else>
                        {{
                          scope.row.invoice_due_date
                            ? moment(scope.row.invoice_due_date).format(
                                "DD/MM/YYYY",
                              )
                            : ""
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Open Head"
                    prop="open_heads"
                    align="center"
                    v-if="!['draft', 'pending'].includes(item.value)"
                  />
                  <el-table-column
                    label="Balance"
                    v-if="!['draft', 'pending'].includes(item.value)"
                  >
                    <template slot="header" slot-scope="scope">
                      Balance
                      <el-tooltip
                        content="Livestock + Mgmt Fee"
                        placement="bottom"
                      >
                        <i class="fas fa-info-circle"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      {{
                        scope.row.contract_balance
                          ? "$" + $_toLocaleString(scope.row.contract_balance)
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="RFIDs"
                    v-if="['draft', 'pending'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      <i
                        class="fa"
                        :class="
                          scope.row.rfis_collections &&
                          scope.row.rfis_collections.length > 0
                            ? 'fa-check text-green'
                            : 'fa-times text-red'
                        "
                      ></i>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Invoice"
                    v-if="['draft', 'pending'].includes(item.value)"
                  >
                    <template slot-scope="scope">
                      <i
                        class="fa"
                        :class="
                          scope.row.invoice_collections &&
                          scope.row.invoice_collections.length > 0
                            ? 'fa-check text-green'
                            : 'fa-times text-red'
                        "
                      ></i>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label=""
                    v-if="['draft', 'pending'].includes(item.value)"
                    width="100px"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="
                          [1, 2].includes(scope.row.purchase_status_id) &&
                          scope.row.pending_client_transactions.length == 0
                        "
                        @click="showPurchaseModal($event, scope.row)"
                        class="btn-secondary"
                      >
                        Edit
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label=""
                    v-if="item.value == 'open' && false"
                  >
                    <template slot-scope="scope">
                      <a
                        href="#"
                        class="pr-2"
                        v-if="false"
                        @click="showStatementModal($event, scope.row)"
                        ><i class="fa fa-file-plus fa-lg"></i
                      ></a>
                      <el-button
                        class="action-btn btn-green rounded"
                        plain
                        type="primary"
                        style="width: 90px"
                      >
                        Payout
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  class="py-3 d-flex justify-content-center justify-content-xl-end"
                >
                  <el-pagination
                    small
                    layout="prev, pager, next, total"
                    :current-page.sync="currentPage"
                    @current-change="handleCurrentChange"
                    :background="true"
                    :page-size="perPage"
                    :page-count="purchases.last_page"
                    :total="purchases.total"
                  />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="col-12 d-lg-none">
          <div v-loading="loading">
            <el-table
              :data="purchases.data"
              :cell-class-name="tableCellClassNameMobile"
              :header-cell-class-name="tableCellClassNameMobile"
            >
              <el-table-column label="" prop="id" width="60px">
                <template slot-scope="scope">
                  <div
                    v-if="
                      scope.row.bsa_executed_collections.length > 0 &&
                      scope.row.invoice_collections.length > 0 &&
                      !['draft', 'pending'].includes(tabValue)
                    "
                  >
                    <el-dropdown>
                      <el-button class="btn-secondary p-1">
                        <i class="far fa-download"></i>
                        <i class="el-icon-arrow-down"></i>
                      </el-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <invoice-button
                            :initial_purchase="scope.row"
                            :show_item="true"
                            v-if="scope.row.invoice_collections.length > 0"
                          ></invoice-button>
                          <bsa-executed-button
                            :initial_purchase="scope.row"
                            :show_item="true"
                            v-if="scope.row.bsa_executed_collections.length > 0"
                          ></bsa-executed-button>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  <div v-else-if="!['draft', 'pending'].includes(tabValue)">
                    <invoice-button
                      :initial_purchase="scope.row"
                      v-if="scope.row.invoice_collections.length > 0"
                    ></invoice-button>
                    <bsa-executed-button
                      :initial_purchase="scope.row"
                      v-if="scope.row.bsa_executed_collections.length > 0"
                    ></bsa-executed-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Trade #" prop="id">
                <template slot-scope="scope">
                  {{ scope.row.ref_id }}
                </template>
              </el-table-column>
              <el-table-column label="Expiry Date" v-if="tabValue == 'open'">
                <template slot-scope="scope">
                  <div
                    :class="expiredDates(scope.row.invoice_due_date)"
                    class="text-center"
                    style="width: 100px"
                    v-if="tabValue == 'open'"
                  >
                    {{
                      scope.row.invoice_due_date
                        ? moment(scope.row.invoice_due_date).format(
                            "DD/MM/YYYY",
                          )
                        : ""
                    }}
                  </div>
                  <div v-else>
                    {{
                      scope.row.invoice_due_date
                        ? moment(scope.row.invoice_due_date).format(
                            "DD/MM/YYYY",
                          )
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Open Head"
                prop="open_heads"
                align="center"
                v-if="!['draft', 'pending'].includes(tabValue)"
              />

              <el-table-column
                label="Balance"
                v-if="!['draft', 'pending'].includes(tabValue)"
              >
                <template slot="header" slot-scope="scope">
                  Balance
                  <el-tooltip content="Livestock + Mgmt Fee" placement="bottom">
                    <i class="fas fa-info-circle"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{
                    scope.row.contract_balance
                      ? $_toLocaleString(scope.row.contract_balance)
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template #default="props">
                  <div class="row">
                    <div class="col-md-3 col-6 py-1 font-weight-bold text-navy">
                      Purchased
                    </div>
                    <div class="col-md-3 col-6 py-1">
                      {{
                        props.row.invoice_invoice_date
                          ? moment(props.row.invoice_invoice_date).format(
                              "DD/MM/YYYY",
                            )
                          : "--"
                      }}
                    </div>
                    <div class="col-md-3 col-6 py-1 font-weight-bold text-navy">
                      Daily Rate
                    </div>
                    <div class="col-md-3 col-6 py-1">
                      {{
                        props.row.channel && props.row.channel.daily_rate
                          ? $_roundAccurately(props.row.channel.daily_rate, 4) +
                            "%"
                          : ""
                      }}
                    </div>
                    <div class="col-md-3 col-6 py-1 font-weight-bold text-navy">
                      Reference
                    </div>
                    <div class="col-md-3 col-6 py-1">
                      {{
                        props.row.reference_code
                          ? props.row.reference_code
                          : "--"
                      }}
                    </div>
                    <div class="col-md-3 col-6 py-1 font-weight-bold text-navy">
                      Daily Mgmt Fee
                    </div>
                    <div class="col-md-3 col-6 py-1">
                      {{
                        "$" +
                        $_toLocaleString(props.row.management_fee_per_day, 4)
                      }}
                    </div>
                    <div class="col-md-3 col-6 py-1 font-weight-bold text-navy">
                      Original Hd
                    </div>
                    <div class="col-md-3 col-6 py-1">
                      {{ props.row.number_of_head }}
                    </div>
                    <div
                      class="col-md-3 col-6 py-1 font-weight-bold text-navy"
                      v-if="!['draft', 'pending', 'closed'].includes(tabValue)"
                    >
                      DOF
                    </div>
                    <div
                      class="col-md-3 col-6 py-1"
                      v-if="!['draft', 'pending'].includes(tabValue)"
                    >
                      {{
                        moment().diff(props.row.invoice_invoice_date, "days")
                      }}
                    </div>

                    <div
                      class="col-md-3 col-6 py-1 font-weight-bold text-navy"
                      v-if="!['draft', 'pending'].includes(tabValue)"
                    >
                      Start Bill Value (inc)
                    </div>
                    <div
                      class="col-md-3 col-6 py-1"
                      v-if="!['draft', 'pending'].includes(tabValue)"
                    >
                      {{
                        props.row.dollar_value
                          ? "$" + $_toLocaleString(props.row.dollar_value)
                          : ""
                      }}
                    </div>

                    <div
                      class="col-md-3 col-6 py-1 font-weight-bold text-navy"
                      v-if="['open'].includes(tabValue)"
                    >
                      Total Sales
                    </div>
                    <div
                      class="col-md-3 col-6 py-1"
                      v-if="['open'].includes(tabValue)"
                    >
                      {{
                        props.row.total_sales_inc
                          ? "$" + $_toLocaleString(props.row.total_sales_inc)
                          : "--"
                      }}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              class="py-3 d-flex justify-content-center justify-content-xl-end"
            >
              <el-pagination
                small
                layout="prev, pager, next, total"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
                :background="true"
                :page-size="perPage"
                :page-count="purchases.last_page"
                :total="purchases.total"
              />
            </div>
          </div>
        </div>
      </div>
      <group-statement-generation
        :initial_business_id="initial_business.id"
        v-if="statementModalShow"
        @close="statementModalShow = false"
        :statement-type-group="statementTypeGroup"
        :purchase_id="selectedPurchaseId"
      ></group-statement-generation>
      <business-sale-form-modal
        :initial_business="business"
        v-if="formModalShow"
        @close="formModalShow = false"
      ></business-sale-form-modal>
      <business-purchase-form-modal
        :initial_business="business"
        :initial_purchase="selectedPurchase"
        v-if="purchaseFormModalShow"
        @close="onClosePurchaseForm"
      ></business-purchase-form-modal>
    </el-card>
  </div>
</template>
<script>
import OttleyFormatter from "../../../../mixins/OttleyFormatter";
import Purchase from "../../../modelsPortal/Purchase";
export default {
  mixins: [OttleyFormatter],
  props: {
    initial_business: {
      type: Object,
    },
    isProducer: {
      type: Number,
    },
    selectedOption: {
      type: Number,
    },
  },
  data() {
    return {
      selectedPageOption: null,
      pageOptions: [
        { name: "Open Trades", id: 1, tab: "open" },
        { name: "Past Trades", id: 2, tab: "closed" },
        { name: "Pending Trades", id: 3, tab: "pending" },
      ],
      business: this.initial_business,
      purchases: [],
      loading: false,
      page: 1,
      currentPage: 1,
      perPage: 5,
      tabs: [
        { value: "open", name: "Open" },
        { value: "closed", name: "Closed" },
        { value: "pending", name: "Pending" },
      ],
      tabValue: "open",
      statementModalShow: false,
      selectedPurchaseId: null,
      purchaseFormModalShow: false,
      formModalShow: false,
      selectedPurchase: null,
    };
  },
  mounted() {
    if (this.selectedOption) {
      this.selectedPageOption = this.pageOptions.find(
        (p) => p.id == this.selectedOption,
      );
      this.tabValue = this.selectedPageOption.tab;
      this.getData(1);
    } else {
      this.getStats();
    }
  },
  methods: {
    tableCellClassNameMobile({ columnIndex }) {
      if ([3, 4, 5].includes(columnIndex) && this.tabValue == "open") {
        return "bg-lightgrey rounded-0 border-0 text-navy";
      }
      return "";
    },
    tableCellClassName({ columnIndex }) {
      if ([11, 12, 13].includes(columnIndex) && this.tabValue == "open") {
        return "bg-lightgrey rounded-0 border-0 text-navy";
      }
      return "";
    },
    onClosePurchaseForm() {
      this.purchaseFormModalShow = false;
      if (this.tabValue == "pending") {
        this.getData(1);
      }
    },
    getStats() {
      this.loading = true;
      let data = {
        "filter[business_id]": this.initial_business.id,
        no_paginate: true,
      };

      axios
        .get(`/api/v2/portal/purchases/stats`, {
          params: data,
        })
        .then((res) => {
          let stats = res.data;
          if (stats.pending > 0) this.tabValue = "pending";
          else this.tabValue = "open";

          this.getData(1);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    getData(page = 1) {
      this.loading = true;
      let includes = [
        "channel",
        "invoiceCollections",
        "sales",
        "bsaExecutedCollections",
      ];
      let appends = [
        "balance",
        "has_pending_sale",
        "paid",
        "is_deprecated",
        "contract_balance_to_date",
        "livestock_deposit",
        "total_sales_inc",
        "pending_total_sales_inc",
        "management_fee_total",
      ];

      if (["draft", "pending"].includes(this.tabValue)) {
        includes = [
          "rfisCollections",
          "invoiceCollections",
          "property",
          "media",
          "clientComment",
          "lineItems",
          "additionalCosts",
          "channel",
          "pendingClientTransactions",
          "bsaExecutedCollections",
        ];
        appends = [];
      }
      let purchases = new Purchase()
        .page(page)
        .where("business_id", this.business.id)
        .append(appends.join(","))
        .include(includes.join(","))
        .params({ per_page: this.perPage });

      if (this.tabValue == "draft") {
        purchases.where("purchase_status_id", 1).where("is_cp", true);
      } else if (this.tabValue == "pending") {
        purchases.whereIn("purchase_status_id", [1, 2]).where("is_cp", true);
      } else {
        purchases.where("open_trades", this.tabValue == "open" ? true : false);
      }

      purchases
        .get()
        .then((res) => {
          this.loading = false;
          this.purchases = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getData(page);
    },
    showStatementModal(event, purchase = null) {
      event.preventDefault();
      this.statementTypeGroup = purchase ? false : true;
      this.statementModalShow = true;
      this.selectedPurchaseId = purchase ? purchase.id : null;
    },
    showPurchaseModal(event, purchase = null) {
      event.preventDefault();
      this.selectedPurchase = purchase;
      this.purchaseFormModalShow = true;
    },
  },
};
</script>
